/**
 * full list of properties on https://github.com/keplergl/kepler.gl/blob/master/src/styles/src/base.ts
 */
export default {
  textColor: 'red',
  titleTextColor: 'yellow'
}